import React from "react";
import { Link } from "react-router-dom";
export default function Banner(props) {
  return (
    <>
    <section className="banner">
    <video
        autoPlay
        loop
        muted
        playsInline
        className="portfolio-video"
      >
        <source src="portfolioback.mp4" type="video/mp4" />
      </video>
      <div className="container">
        <div className="row">
          <div className="col-md-6">
          <img
                src={props.image}
                className="img-fluid d-block w-100 opacity-8"
                alt="..."
              />
          </div>
          <div className="col-md-6">
         <div className="BannerCaption">
  {props.badge && (
    <div className="availability-badge">
      <span className="status-dot"></span>
      {props.badge}
    </div>
  )}

  <h5
    data-aos="fade-up-right"
    data-aos-easing="ease-out-cubic"
    data-aos-duration="1000"
    data-aos-delay="500"
  >
    {props.heading}{" "}
    <span className="heading2">{props.heading2}</span>
  </h5>

  <p
    data-aos="fade-up-right"
    data-aos-easing="ease-out-cubic"
    data-aos-duration="1000"
    data-aos-delay="700"
  >
    {props.details}
  </p>

  <Link
    to={props.serviceLink || "/contact"}
    className={`btn btn-${
      props.mode === "light" ? "primary3" : "primary2"
    }`}
  >
    {props.buttonText}
  </Link>
</div>
          </div>
        </div>
      </div>
      </section>
    </>
  );
}
